import { mapGetters } from 'vuex'

/**
 * --- WARNING! ---
 * @deprecated This mixin facilitates an outdated feature flag implementation and will be removed.
 */

export default {
  computed: {
    ...mapGetters({
      featureFlags: 'features/featureFlags',
    }),
    selfServiceFeatureFlags() {
      return this.featureFlags.selfService
    },
  },
}
